import { makeStyles } from '@material-ui/core';
import { HOT_NOTE_BG_COLOR } from './HotNotePanelConsts';

export const hotNotePanelStyles = makeStyles(theme => ({
    panel: {
        marginLeft: theme.spacing(2),
        maxWidth: 480,
        minWidth: 180,
        backgroundColor: HOT_NOTE_BG_COLOR,
        border: `1px solid ${theme.palette.warning.light}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0.5, 1.5),
        alignSelf: 'center',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    label: {
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.5,
        color: '#CC5500',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
    },
    content: {
        fontSize: 13,
        color: '#CC5500',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        cursor: 'pointer',
        flex: 1,
        minWidth: 0,
        '& p': { margin: 0 },
    },
    contentExpanded: {
        whiteSpace: 'normal',
        overflow: 'visible',
        textOverflow: 'unset',
    },
    empty: {
        fontSize: 13,
        color: theme.palette.text.disabled,
    },
    editIconBtn: {
        padding: 2,
        marginLeft: theme.spacing(0.5),
    },
    addBtn: {
        fontSize: 12,
        padding: 0,
        minWidth: 'unset',
        textTransform: 'none',
        color: theme.palette.primary.main,
    },
}));
